var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group mt-2" }, [
    _c(
      "label",
      { staticClass: "form-label", attrs: { for: "payment_online" } },
      [_vm._v("\n        Співробітник\n    ")]
    ),
    _vm._v(" "),
    _vm.draw_items.length > 0
      ? _c(
          "div",
          {},
          [
            _c(
              "v-select",
              {
                staticClass: "imc_reasons",
                attrs: {
                  id: "users_list",
                  reduce: (item) => item.id,
                  label: "name",
                  options: this.draw_items,
                  searchable: true,
                  filterable: true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return [
                          _c("div", { staticClass: "pt-2 pb-2" }, [
                            _c(
                              "div",
                              { staticClass: "icon-stack fs-xl mr-3" },
                              [
                                _c("i", {
                                  staticClass:
                                    "base base-19 icon-stack-3x opacity-100 color-primary-500",
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "base base-2 icon-stack-2x opacity-100 color-primary-300",
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "fas fa-arrow-right icon-stack-1x opacity-100 color-white",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "imc_opt" }, [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(option.name) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2197819256
                ),
                model: {
                  value: _vm.active_dep_id,
                  callback: function ($$v) {
                    _vm.active_dep_id = $$v
                  },
                  expression: "active_dep_id",
                },
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v("\n                Оберіть організацію\n            "),
                ]),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }